import { useState, useCallback } from 'react'
import { referencesAPI } from '../services/api'
import toast from 'react-hot-toast'

export const useReferences = () => {
  const [template, setTemplate] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const downloadTemplate = useCallback(async (type) => {
    setLoading(true)
    setError(null)
    try {
      const response = await referencesAPI.getTemplate(type)
      setTemplate(response.data)
      const element = document.createElement('a')
      const file = new Blob([response.data.template], { type: 'text/csv' })
      element.href = URL.createObjectURL(file)
      element.download = `template_${type}.csv`
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)
      toast.success('Шаблон выгружен')
      return response.data
    } catch (err) {
      setError(err.message)
      toast.error('Ошибка выгрузки шаблона')
      throw err
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    loading,
    error,
    downloadTemplate
  }
}
